/**
 * Centralized store for sharing data between components
 *
 * To use in a component:
 * import store from "@/store.js";
 * then set data: { shared: store.state }
 *
 */
import { api } from "@@/services/ladder";

let store = {
    debug: process.env.NODE_ENV != "production",
    state: {
        initialized: false,
        // The cart is for future use
        cart: [],
        // We'll only allow for one offer active at all times
        offer: null,
        // The logged in user
        user: null,
        // Used to check if there is an auth token on load
        token: localStorage["__LADDER_AUTH_TOKEN"]
    },
    addItemToCart(item) {
        if (this.debug) console.log("addItemAction triggered with", item);
        this.state.items.push(item);
    },
    setOffer(offer) {
        if (this.debug) console.log("setOfferAction triggered");

        if (offer != null && offer.constructor.name === "Object") {
            this.state.offer = offer;
            localStorage._offerToken = offer.token;
        } else {
            if (this.debug) console.error("Offer must be an object");
        }
    },
    removeOffer() {
        if (this.debug) console.log("removeOfferAction triggered");
        this.state.offer = null;
        localStorage.removeItem("_offerToken");
    },
    setUser(user) {
        // Verify the user is an object
        if (user != null && user.constructor.name === "Object") {
            this.state.user = user;
        } else {
            if (this.debug) console.log("User must be an object");
        }
    }
};

// We cache the last token they accessed
// Retreive on load every time so they can continue
if (localStorage._offerToken) {
    api.read(`offers/${localStorage._offerToken}`)
        .then(offer => {
            if (!store.state.offer) {
                store.setOffer(offer);
            }
        })
        .catch(() => {
            if (!store.state.offer) {
                store.removeOffer();
            }
        })
        .finally(() => {
            store.state.initialized = true;
        });
} else {
    store.state.initialized = true;
}

export default store;
